export default __webpack_public_path__ + "static/media/Punto_03_Monumento_4_Mori_e_Fortezza_Vecchia_SPA_Def.f7c4b819.aac";